const TT_AND_AUTO_WP_COPY = {
  DISCLAIMER:
    "These suggestions have been generated by an AI model, but the ideas and underlying gist are original and generated by a human author.",
  REPORT_FEEDBACK:
    "Describe the problem you are experiencing. Your feedback helps us improve results.",
} as const;

export default TT_AND_AUTO_WP_COPY;
